import { BaseAction } from "./BaseAction";
export class InlineAction extends BaseAction {
    execute() {
        this.renderTemplate();
        return true;
    }
}
